<template>
        <span
        class="text-danger">
        <i
            class="fa fa-times fa-lg icon-button mr-1"
            title="Reprovar Conformidade Técnica"
            @click.stop="confirmarReprovarConformidadeTecnica()"
        ></i>
        </span>
</template>

<script>

export default {
    props: {
        pleito: {
            type: Object
        },

        servicos: {
            type: Object
        },
    },

    methods: {
        confirmarReprovarConformidadeTecnica() {
            this.$swal({
                title: 'Reprovar Conformidade Técnica do Pleito',
                html: `Confirma a <strong>REPROVAÇÃO DA CONFORMIDADE TÉCNICA</strong> do pleito <b>${this.pleito.descritivo}</b>?`,
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a Justificativa`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa é obrigatória'`
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovarConformidadeTecnica(result.value)
                }
            })
        },

        reprovarConformidadeTecnica(justificativa) {
            this.$store.dispatch('addRequest')
            this.servicos.reprovarConformidadeTecnica(this.pleito.pleitoId, justificativa).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Conformidade Técnica do pleito reprovada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('listarPleitos')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}

</script>